import { useState } from 'react';

import { IMultiDataTableFilter } from '@interfaces/components/table';

import MultiDataFilterChip from './MultiDataFilterChip/MultiDataFilterChip';

import styles from './MultiDataFilter.module.scss';

interface IMultiDataFilterProps {
	multiDataFilters: IMultiDataTableFilter;
}

const MultiDataFilter = ({
	multiDataFilters,
}: IMultiDataFilterProps) => {
	const { selectedFilters, filterProps, setSelectedFilters } = multiDataFilters;
	const { name, subName } = filterProps;

	const [openIdx, setOpenIdx] = useState<number | null>(null);

	const clearSelectionAtIndex = (index: number) => {
		setSelectedFilters((prev) => {
			const updatedFilters = prev.map((item, idx) => {
				if (index === idx) {
					return { ...item, [name]: null, [subName]: null };
				}

				return item;
			});

			const data = prev.length > 1
				? updatedFilters.filter((_, i) => i !== index)
				: updatedFilters;

			const isEmptyOptionExist = data.some(option => !option[name]?.value && !option[subName]?.value);

			return isEmptyOptionExist ? data : [...data, { [name]: null, [subName]: null }];
		});

		setOpenIdx(null);
	};

	return (
		<div className={styles.container}>
			{selectedFilters?.map((filter, index) => (
				<MultiDataFilterChip
					key={`multi-data-filter-${index}`}
					clearSelectionAtIndex={clearSelectionAtIndex}
					filter={filter}
					filterProps={filterProps}
					index={index}
					name={name}
					openIdx={openIdx}
					setOpenIdx={setOpenIdx}
					setSelectedFilters={setSelectedFilters}
					subName={subName}
				/>
			))}
		</div>
	);
};

export default MultiDataFilter;
